export const agentOptions = {
  AGENT_ASSIGNATION: 'AGENT_ASSIGNATION',
  UNASSIGN_AGENT: 'UNASSIGN_AGENT'
};

export default agentOptions;
